<template>
  <div class="ChallengesTopicsSearchBar">
    <div class="container-fluid">
      <div class="row margin-Top-2Perc margin-left-1Perc">
        <button type="button" class="btn black-border custom-btn white-BG" @click="openCreateTopicOverlay($event,true)">+ Create New</button>
      </div>
    </div>
    <create-topic-overlay v-if="showCreateTopicOverlay" @updateFlag="updateCreateTopicOverlayFlag"></create-topic-overlay>
  </div>
</template>
<script>
import CreateTopicOverlay from '@/components/CreateTopicOverlay'
export default {
  data: function () {
    return {
      showCreateTopicOverlay: false
    }
  },
  components: {
    'create-topic-overlay': CreateTopicOverlay
  },
  methods: {
    updateCreateTopicOverlayFlag (value) {
      // AK: Used to update the Flag when user pressed Close or Added Successfully in Topic list
      this.showCreateTopicOverlay = value
      // AK: Enabled Background scrolling
      this.$store.state.isOverlayVisible = value
    },
    openCreateTopicOverlay ($event, flagToUpdate) {
      // AK: Used when user pressed Create Topic Button
      this.showCreateTopicOverlay = flagToUpdate
      // AK: Enabled Background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    }
  }
}
</script>
<style scoped>
.ChallengesTopicsSearchBar{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.margin-left-1Perc {
    margin-left: 1%;
}
.margin-Top-2Perc{
  margin-Top:2% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ChallengesTopicsSearchBar.vue